import { TProjectDetailState } from '@/redux/reducers/project-detail';
import { TPostProjectDetailSuccess } from '@/redux/actions/project-detail';

export const postProjectDetailUpdateState = (
  state: TProjectDetailState,
  action: TPostProjectDetailSuccess,
): TProjectDetailState => {
  const updatedState = {
    ...state,
    postProjectDetailResponse: action.payload.response,
  };

  return updatedState;
};
